<template>
  <base-line-chart
    :chart-data="getChartData"
    :options="getChartOptions">
  </base-line-chart>
</template>

<script>
import colorMixin from '@/mixins/colors';
import BaseLineChart from './base/BaseLineChart';

export default {
  name: 'LineChart',
  components: {
    BaseLineChart,
  },
  mixins: [colorMixin],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'title',
    },
    showLegend: {
      type: Boolean,
      default: false,
    },
    labels: {
      type: Array,
      default: () => [],
    },
    yAxeslabelString: {
      type: String,
      default: '',
    },
    xAxeslabelString: {
      type: String,
      default: '',
    },
    showGridLines: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getChartData() {
      if (!this.data.length) {
        return {};
      }
      const datasets = this.data.map((d, i) => ({
        data: d.map(s => s[1]),
        backgroundColor: this.generateRGBAColor(`${i}1`, 0.5, [185, 340]),
        borderColor: this.generateRGBAColor(`${i}1`, 1),
        tension: 0.3,
        borderWidth: 1,
        label: this.labels[i],
      }));

      return {
        labels: this.data[0].map(s => s[0]),
        datasets,
      };
    },

    getChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.showLegend,
        },
        tooltips: {
          callbacks: {
            label: tooltipItem => tooltipItem.yLabel,
          },
        },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: this.yAxeslabelString,
            },
          }],
          xAxes: [{
            gridLines: {
              display: this.showGridLines,
            },
            scaleLabel: {
              display: true,
              labelString: this.xAxeslabelString,
            },
          }],
        },
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// LineChart.vue?e4d320b2